<div>
  <div>
    <div style="display: flex; justify-content: center; margin: 100px;">
      <img *ngIf="!isDarkMode()" style="width: 277px" src="/assets/images/lexbe-logo.svg" alt="lexbe-logo">
      <img *ngIf="isDarkMode()" style="width: 277px" src="/assets/images/lexbe-logo-dark-theme-3.svg" alt="lexbe-logo">
    </div>
    <div style="width: 730px; margin: auto;" *ngIf="fileDetails$ | async as fileDetails">
      <mat-card appearance="outlined" class="lexbe-card" *ngIf="fileDetails.lifeCycle !== LifeCycle.Deleted">
        <mat-card-header>Download File</mat-card-header>
        <mat-card-content>
          <p>You have been given access to download the file <strong>{{fileDetails.name}}</strong>. Please click below
            to start
            your download.</p>
          <div style="padding: 40px 0 5px 0; text-align: center;">
            <button mat-raised-button class="lexbe-button blue" (click)="download()">
              <mat-icon style="font-size: 18px;">download</mat-icon>
              <span>Start Download ({{fileDetails.size}})</span>
            </button>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" class="lexbe-card" *ngIf="fileDetails.lifeCycle === LifeCycle.Deleted">
        <mat-card-header>Briefcase Deleted</mat-card-header>
        <mat-card-content>
          <p class="delete-message">The Briefcase you are trying to access has been deleted.</p>
        </mat-card-content>
      </mat-card>
    </div>

  </div>


</div>